import { render, staticRenderFns } from "./CategoriesOfTheWeek.vue?vue&type=template&id=0d13f91e"
import script from "./CategoriesOfTheWeek.vue?vue&type=script&lang=js"
export * from "./CategoriesOfTheWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports